import { Card, CardContent, Typography, Box } from "@mui/material";

export default function YouTubeVideo({ url, title, videoHeight}) {
  return (
    <Card
      sx={{
        borderRadius: 3,
        overflow: "hidden", // fa combaciare bordi del video e card
        boxShadow: 3
      }}
    >
      <CardContent
        sx={{
          pb: 0, // rimuove spazio sotto al titolo
        }}
      >
        <Typography
          variant="subtitle1"
          align="center"
          sx={{ fontWeight: 500, mb: 1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}
        >
          {title}
        </Typography>
      </CardContent>

      {/* Container video */}
      <Box
        sx={{
          position: "relative",
          mb: "-8px",
          height: videoHeight
        }}
      >
        <iframe
          src={url}
          title={title}
          allowFullScreen
          style={{
            height: "inherit",
            width: "100%",
            border: "none",
            borderRadius: "0 0 12px 12px", // arrotonda solo i bordi inferiori
            overflow: "hidden"
          }}
        />
      </Box>
    </Card>
  );
}